import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { postMACAA020 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_APPROVE } from '../../../shared/constants/app';
import { formatDateTime, formatNumberWithCommas } from '../../../utils';

const MACAA020 = () => {
    const [data, setData] = useState([]);
    const [pages, setPages] = useState({});
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;

    const getListData = () => {
        postMACAA020({ page })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };
    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_APPROVE} />
                <div className="content-right">
                    <h1 className="title">업계추정광고</h1>
                    <div className="note">
                        ** 하기 집계수량은 해당페이지를 조회하는 일자기준(실시간,{' '}
                        {moment().format('YYYY-MM-DD a hh:mm:ss')})입니다.
                        <br />
                        ** 리스트에 출력된 내용은 현재 덴탈잡에 노출되는 광고 중 사업장 구분이 일반(기타) 이거나
                        회원구분이 기타인 회원정보 기준입니다.
                    </div>
                    <div className="results gray">
                        <div className="count">
                            추정광고 수 <span className="red">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                        </div>
                        <table className="table table-gray">
                            <thead>
                                <tr>
                                    <th>아이디</th>
                                    <th>이름</th>
                                    <th>치과명</th>
                                    <th>기관구분</th>
                                    <th>회원구분</th>
                                    <th>채용공고 제목</th>
                                    <th>모집기간</th>
                                    <th>등록일</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.memberID}</td>
                                            <td>{item.nameKor}</td>
                                            <td>{ }</td>
                                            <td>{item.bizCompany}</td>
                                            <td>{ }</td>
                                            <td>{ }</td>
                                            <td>{ }</td>
                                            <td>{formatDateTime(item?.regDate)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={8}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MACAA020;
